import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied';

function PoorEmoji() {
  return (
    <SentimentVeryDissatisfiedIcon
      style={{
        border: '1px solid black',
        background: 'red',
        fontSize: '36px',
        color: 'black',
      }}
    />
  );
}

export default PoorEmoji;
